/* NUVAE storefront helpers: launch countdown, bundle picker, sticky bar */
(function () {
  if (window.__NUVAE__) return;
  window.__NUVAE__ = true;

  /* =====================================================================
     LAUNCH OFFER END DATE (US Eastern Time).
     Change this single line to move the countdown. When the date passes,
     every "launch offer" mention and timer hides itself automatically.
     ===================================================================== */
  var NUVAE_DEADLINE = '2026-10-31T23:59:59-04:00';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function tick() {
    var diff = Date.parse(NUVAE_DEADLINE) - Date.now();
    var timers = document.querySelectorAll('[data-nv-countdown]');
    if (!(diff > 0)) {
      document.querySelectorAll('[data-nv-hide-after-deadline]').forEach(function (el) { el.style.display = 'none'; });
      timers.forEach(function (el) { el.textContent = ''; });
      return false;
    }
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var txt = (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    timers.forEach(function (el) { el.textContent = txt; });
    return true;
  }

  function initBundles(box) {
    if (box.getAttribute('data-nv-ready')) return;
    box.setAttribute('data-nv-ready', '1');
    var root = box.closest('product-info') || box.closest('section') || document.body;
    root.classList.add('nv-has-bundles');
    var cards = box.querySelectorAll('[data-nv-bundle]');

    function mark(id) {
      cards.forEach(function (c) {
        var on = c.getAttribute('data-variant-id') === String(id);
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function pick(card) {
      var value = card.getAttribute('data-option-value');
      var target = null;
      /* Dawn swaps in a fresh <variant-selects> before removing the old one,
         so the first match is always the live picker. */
      root.querySelectorAll('variant-selects input[type="radio"]').forEach(function (i) {
        if (!target && i.value === value) target = i;
      });
      if (target) {
        if (!target.checked) {
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        var sel = root.querySelector('variant-selects select');
        if (sel) {
          sel.value = value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      mark(card.getAttribute('data-variant-id'));
    }

    cards.forEach(function (c) {
      c.addEventListener('click', function () { pick(c); });
    });

    var fromUrl = new URLSearchParams(window.location.search).get('variant');
    if (fromUrl) { mark(fromUrl); return; }
    var def = box.querySelector('[data-nv-bundle][data-nv-default]');
    if (def) { pick(def); return; }
    var idInput = root.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput) mark(idInput.value);
  }

  function initSticky() {
    var bar = document.querySelector('[data-nv-sticky]');
    var anchor = document.getElementById('nv-bundles');
    if (!bar || !anchor) return;
    /* Show the bar only once the offer cards and the buy buttons are scrolled past. */
    var ref = document.querySelector('product-form') || anchor;
    var queued = false;
    function update() {
      queued = false;
      bar.classList.toggle('is-visible', ref.getBoundingClientRect().bottom < 0);
    }
    function onScroll() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function initScrollLinks() {
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('a[href="#nv-bundles"]');
      if (!a) return;
      var t = document.getElementById('nv-bundles');
      if (!t) return;
      ev.preventDefault();
      t.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function init() {
    if (tick()) setInterval(tick, 1000);
    document.querySelectorAll('[data-nv-bundles]').forEach(initBundles);
    initSticky();
    initScrollLinks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
